export default "__VITE_ASSET__Bwr$pib8__"